import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from "@material-ui/core";
import { isArray } from "lodash";
import RootRef from "@material-ui/core/RootRef";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { connect, useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { useSortReportCategory } from "../../utils";
import { AntSwitch } from "components/HeaderProject/components/SortListColumn";
import { apiService } from "constants/axiosInstance";
import { useTranslation } from "react-i18next";
import {
  getReportCategoriesSuccess,
  updateModalReport,
} from "../../controllers/actions";
import {
  selectModalReport,
  selectReportCategories,
} from "../../controllers/selectors";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AlertModal from "components/AlertModal";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import PopoverMore from "../PopoverMore";
import { actionToast } from "actions/system/system";
import { viewPermissionsSelector } from "views/ProjectPage/selectors";
import { useParams } from "react-router-dom";

const useStyles = makeStyles({
  btnEditReport: {
    minWidth: 30,
    maxWidth: 40,
    margin: "0px 3px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  iconColor: {
    color: "#505050",
  },
  listReport: {
    marginTop: "16px",

    "&>li:first-child": {
      borderTop: "1px solid rgba(0, 0, 0, 0.1) !important",
    },
  },
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const SortReport = ({ category, viewPermissions }) => {
  const css = useStyles();
  const { t } = useTranslation();
  const { reports } = category;
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [alertReportItem, setAlertReportItem] = React.useState(false);
  const handleToast = async (type, message) => {
    dispatch(actionToast(type, message));
    setTimeout(() => dispatch(actionToast(null, "")), 2000);
  };
  const reportCategories = useSelector(selectReportCategories());
  const { selectedReport } = useSelector(selectModalReport());

  const isWebview = document.location.pathname.search("webview") !== -1;
  const canUpdate =
    viewPermissions?.permissions?.[projectId]?.update_project ?? false;

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const newItems = reorder(
      reports,
      result.source.index,
      result.destination.index
    );
    let tmp = reportCategories.map((item) => {
      if (item.id === category.id) {
        return {
          ...item,
          reports: newItems,
        };
      }
      return item;
    });
    try {
      const response = await apiService({
        url: "/project/report/sort-report",
        method: "POST",
        data: {
          report_id: reports[result.source.index].id,
          sort_index: result.destination.index + 1,
        },
      });
      if (response?.data?.state) {
        dispatch(getReportCategoriesSuccess(tmp));
        SnackbarEmitter(
          SNACKBAR_VARIANT.SUCCESS,
          DEFAULT_MESSAGE.MUTATE.SUCCESS
        );
      } else {
        SnackbarEmitter(
          SNACKBAR_VARIANT.ERROR,
          response?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
        );
      }
    } catch (e) {
      SnackbarEmitter(SNACKBAR_VARIANT.ERROR, DEFAULT_MESSAGE.MUTATE.ERROR);
    }
  };

  if (!isArray(reports)) return <></>;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <RootRef rootRef={provided.innerRef}>
            <List className={css.listReport}>
              {reports?.length === 0 && (
                <i>{t("views.report_page.NO_REPORTS")}</i>
              )}
              {reports?.length > 0 &&
                reports?.map((item, index) => {
                  return (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <ListItem
                          ref={provided.innerRef}
                          {...(canUpdate &&
                            !isWebview &&
                            provided.draggableProps)}
                          {...(canUpdate &&
                            !isWebview &&
                            provided.dragHandleProps)}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          {canUpdate && !isWebview && (
                            <ListItemIcon style={{ minWidth: "20px" }}>
                              <DragIndicatorIcon
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  fill: "#6d6e6f",
                                }}
                              />
                            </ListItemIcon>
                          )}
                          <ListItemText
                            primary={item?.name}
                            style={{ color: "#1e1f21" }}
                          />
                          <div
                            style={{
                              cursor:
                                canUpdate && !isWebview
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            <AntSwitch
                              disabled={!canUpdate || isWebview}
                              defaultChecked={!item?.is_hidden}
                              onChange={async (e) => {
                                try {
                                  const response = await apiService({
                                    url: "/project/report/set-status-report",
                                    method: "POST",
                                    data: {
                                      report_id: item.id,
                                      status: e.target.checked ? 1 : 2,
                                    },
                                  });
                                  let tmp = reportCategories.map((cate) => {
                                    if (cate.id === category.id) {
                                      return {
                                        ...cate,
                                        reports: cate.reports.map((e) => {
                                          if (e.id === item.id) {
                                            return {
                                              ...e,
                                              is_hidden: !e.is_hidden,
                                            };
                                          }
                                          return e;
                                        }),
                                      };
                                    }
                                    return cate;
                                  });
                                  if (response?.data?.state) {
                                    dispatch(getReportCategoriesSuccess(tmp));
                                    SnackbarEmitter(
                                      SNACKBAR_VARIANT.SUCCESS,
                                      DEFAULT_MESSAGE.MUTATE.SUCCESS
                                    );
                                  } else {
                                    SnackbarEmitter(
                                      SNACKBAR_VARIANT.ERROR,
                                      response?.msg ??
                                        DEFAULT_MESSAGE.MUTATE.ERROR
                                    );
                                  }
                                } catch (e) {
                                  SnackbarEmitter(
                                    SNACKBAR_VARIANT.ERROR,
                                    DEFAULT_MESSAGE.MUTATE.ERROR
                                  );
                                }
                              }}
                              style={{ marginRight: 5 }}
                              inputProps={{ "aria-label": "ant design" }}
                            />
                          </div>
                          {canUpdate && !isWebview ? (
                            <PopoverMore
                              items={[
                                // {
                                //   title: t("IDS_WP_EDIT"),
                                //   onClick: () => {
                                //     // handleEditCategory(report);
                                //     dispatch(
                                //       updateModalReport({
                                //         openCreateReport: true,
                                //         edit: true,
                                //         selectedReport: item,
                                //       })
                                //     );
                                //   },
                                // },
                                {
                                  title: t("IDS_WP_DELETE"),
                                  onClick: () => {
                                    setAlertReportItem(true);
                                    dispatch(
                                      updateModalReport({
                                        selectedReport: item,
                                      })
                                    );
                                  },
                                  sx: { color: "red" },
                                },
                              ]}
                            >
                              <Button
                                variant="text"
                                className={css.btnEditReport}
                              >
                                <MoreHorizIcon />
                              </Button>
                            </PopoverMore>
                          ) : (
                            <div style={{ width: "35px" }} />
                          )}
                        </ListItem>
                      )}
                    </Draggable>
                  );
                })}
              {provided.placeholder}
            </List>
          </RootRef>
        )}
      </Droppable>
      <AlertModal
        open={alertReportItem}
        setOpen={setAlertReportItem}
        content={t("IDS_WP_ALERT_CONTENT")}
        onConfirm={async () => {
          try {
            const response = await apiService({
              url: "/project/report/delete-report",
              method: "POST",
              data: {
                report_id: selectedReport.id,
              },
            });
            if (response?.data?.state) {
              const arr = reportCategories.map((item) => {
                if (item.id === category.id) {
                  const clone = JSON.parse(JSON.stringify(item));
                  clone.reports = (clone?.reports ?? []).filter(
                    (item) => item.id !== selectedReport.id
                  );
                  return clone;
                }

                return item;
              });
              dispatch(getReportCategoriesSuccess(arr));
              handleToast("success", t("IDS_WP_DELETE_COMPLETE"));
            } else {
              SnackbarEmitter(
                SNACKBAR_VARIANT.ERROR,
                response?.data?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
              );
            }
          } catch (err) {
            SnackbarEmitter(
              SNACKBAR_VARIANT.ERROR,
              DEFAULT_MESSAGE.MUTATE.ERROR
            );
          }
        }}
      />
    </DragDropContext>
  );
};

const mapStateToProps = (state) => {
  return {
    viewPermissions: viewPermissionsSelector(state),
  };
};

export default connect(mapStateToProps, (state) => {})(SortReport);

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,
  ...(isDragging && {}),
  border: "0px",
  // borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  borderBottom: "1px solid",
  borderColor: "rgba(0, 0, 0, 0.1)",
  color: "#666",
  marginBottom: 0,
  "& > div": {
    paddingLeft: 0,
  },
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "0",
  padding: "8px 4px",
});
